import { render, staticRenderFns } from "./StandaloneApp.vue?vue&type=template&id=6577eea2"
import script from "./StandaloneApp.vue?vue&type=script&lang=js"
export * from "./StandaloneApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports